import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function CitePage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Citation</b>
        </h2>
      }
      text_content={
        <div>
          <br />{" "}
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
             
                  <div class="style40">
                  <ol>

Ramachandra TV, Setturu B, Naik KR, Pai JB. Conservation Prioritization of Ecologically Susceptible Zones at Disaggregated Levels.&nbsp;<em>Adv Environ Eng Res</em>&nbsp;<strong>2022</strong>; 3(2): 014; <a href="https://www.lidsen.com/journals/aeer/aeer-03-02-014">doi:10.21926/aeer.2202014.</a>

</ol>
                  </div>
                  <div class="style39">&nbsp;</div>
                  <div class="style39">
                    <table
                      align="center"
                      width="100%"
                      cellspacing="0"
                      cellpadding="0"
                    >
                      <tbody>
                        <tr>
                          <td colspan="4" height="30">
                            <span class="style40">
                              <strong>* Corresponding Author :</strong>
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td width="9%" height="104">
                            &nbsp;
                          </td>
                          <td width="91%">
                            <span class="style40">
                              <strong>Dr. T.V. Ramachandra</strong>
                              <br />
                              Energy &amp; Wetlands Research Group, Centre for
                              Ecological Sciences, Indian Institute of Science,
                              Bangalore &ndash; 560 012, India.
                              <br />
                              Tel : +91-80-2293 3099/2293 3503 [extn - 107],
                              &nbsp;&nbsp;&nbsp;&nbsp; Fax : 91-80-23601428 /
                              23600085 / 23600683 [CES-TVR]
                              <br />
                              E-mail :&nbsp;
                              <a
                                title="mailto:cestvr@ces.iisc.ac.in"
                                href="mailto:cestvr@ces.iisc.ac.in"
                              >
                                cestvr@ces.iisc.ac.in
                              </a>
                              ,&nbsp;
                              <a
                                title="mailto:energy@ces.iisc.ac.in"
                                href="mailto:energy@ces.iisc.ac.in"
                              >
                                energy@ces.iisc.ac.in
                              </a>
                              <br /> Web :&nbsp;
                              <a
                                title="http://wgbis.ces.iisc.ac.in/energy"
                                href="http://wgbis.ces.iisc.ac.in/energy"
                                target="_blank"
                              >
                                http://wgbis.ces.iisc.ac.in/energy
                              </a>
                              ,&nbsp;
                              <a
                                title="http://ces.iisc.ac.in/grass"
                                href="http://ces.iisc.ac.in/grass"
                                target="_blank"
                              >
                                http://ces.iisc.ac.in/grass
                              </a>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                
            </p>
          </p>
          <br />
          <br />
          <hr />
          <br />
        </div>
      }
    />
  );
}
export default CitePage;
